<!--
Copyright 2017 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <div id="user-home">
    <page-head>
      <template #title>{{ $t('title') }}</template>
      <template #tabs>
        <li :class="tabClass('')" role="presentation">
          <router-link :to="tabPath('')">{{ $t('tab.users') }}</router-link>
        </li>
        <li class="disabled" role="presentation">
          <a href="#">
            {{ $t('tab.roles') }}
            <span class="coming-soon">{{ $t('comingSoon') }}</span>
          </a>
        </li>
      </template>
    </page-head>
    <page-body>
      <router-view/>
    </page-body>
  </div>
</template>

<script>
import PageBody from '../page/body.vue';
import PageHead from '../page/head.vue';
import tab from '../../mixins/tab';

export default {
  name: 'UserHome',
  components: { PageBody, PageHead },
  mixins: [tab()],
  computed: {
    tabPathPrefix() {
      return '/users';
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/scss/variables';

#user-home .coming-soon {
  color: $color-text;
  font-size: 10px;
}
</style>

<i18n lang="json5">
{
  "en": {
    // This is shown as the title at the top of the page.
    "title": "User Settings",
    "tab": {
      "users": "Web Users",
      "roles": "Role Settings"
    },
    // This is shown within a disabled navigation tab to indicate that the
    // functionality is not yet implemented, but will be soon.
    "comingSoon": "(coming soon)"
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "title": "Uživatelské nastavení",
    "tab": {
      "users": "Uživatelé webu",
      "roles": "Nastavení role"
    },
    "comingSoon": "(již brzy)"
  },
  "de": {
    "title": "Benutzer-Einstellungen",
    "tab": {
      "users": "Web-Benutzer",
      "roles": "Rollen-Einstellungen"
    },
    "comingSoon": "(bald verfügbar)"
  },
  "es": {
    "title": "Configuraciones del usuario",
    "tab": {
      "users": "Usuarios Web",
      "roles": "Administración de Roles"
    },
    "comingSoon": "(próximamente)"
  },
  "fr": {
    "title": "Paramètres d'utilisateur",
    "tab": {
      "users": "Utilisateur web",
      "roles": "Paramètres de rôle"
    },
    "comingSoon": "(bientôt disponible)"
  }
}
</i18n>
